/*eslint-disable*/
import { postRequest } from './api'

export async function commandRun(values) {
  return postRequest(`ftp/cmd`, values)
}
 